import React, { useEffect, useState } from 'react';
import { Box, Grid, Modal, Tab, Tabs } from '@mui/material';
import { ApiManager } from '../../services/api';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toAbsolutePath } from '../../constants/shared-methods';
import { CSVLink } from 'react-csv';
import { routesName } from '../../constants/routes-name';
import moment from 'moment/moment';
import { MessagePopup, SendChat } from '../../components';
import { useSelector } from 'react-redux';
import BreadcrumbsWrapper from '../../components/BreadcrumbsWrapper';

function Component() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const params = useParams();
  const { user } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(tab ? Number(tab) : 0);
  const [tenderLogs, setTenderLogs] = useState();
  const [bids, setBids] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [modalData, setModalData] = useState();
  const [isViewBid, setIsViewBid] = useState(false);
  const [messages, setMessages] = useState([]);
  const [replyTo, setReplyTo] = useState('');
  const [isMessagePopup, setIsMessagePopup] = useState(false);
  const [tenderData, setTenderData] = useState({
    tenderTitle: '',
    refNo: '',
    publicationDate: '',
    publicationTime: '',
    publicationTimeZone: '',
    submissionDate: '',
    submissionTime: '',
    submissionTimeZone: '',
    beneficiatyLocation: '',
    unspscAndCpvCode: '',
    procedureType: '',
    introduction: '',
    files: [],
    submissionInstructions: '',
    deadlineForQueries: '',
    userKey1: '',
    userKey2: '',
    userKey3: '',
  });

  const toggleMessagePopup = () => setIsMessagePopup((view) => !view);
  const toggleViewBid = () => setIsViewBid((view) => !view);

  const getTenderById = async () => {
    const res = await ApiManager.getTenderById(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const { ...data } = res.data.result;
      setTenderData({ ...tenderData, ...data });
    }
    setLoading(false);
  };

  const getChatsByTender = async () => {
    const res = await ApiManager.getChatsByTender(params.id);
    if (res?.status === 200 && res?.data?.result) {
      setMessages(res?.data?.result);
    }
  };

  const getAllBidsByTenderId = async () => {
    const res = await ApiManager.getAllBidsByTenderId(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const data = res.data.result;
      setBids(data);
    }
    setLoading(false);
  };

  const getTenderChangeHistory = async () => {
    const res = await ApiManager.getTenderChangeHistory(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const data = res.data.result;
      setTenderLogs(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (params.id) {
      getChatsByTender();
      getTenderById();
      getTenderChangeHistory();
      getAllBidsByTenderId();
    } else {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    if (tenderLogs && Array.isArray(tenderLogs)) {
      var arr = [
        [tenderData?.tenderTitle || ''],
        ['Changed By', 'Changed At', 'Key', 'Old Value', 'New Value'],
      ];
      tenderLogs.map((tender, item) => {
        if (Array.isArray(tender.changes)) {
          tender.changes.map((change, ind) => {
            var data = [];
            if (ind === 0) {
              data.push(tender?.updatedBy?.name || '');
              data.push(tender?.createdAt || '');
            } else {
              data.push('');
              data.push('');
            }
            data.push(change?.key || '');
            data.push(change?.old || '');
            data.push(change?.new || '');
            arr.push(data);
          });
        }
      });
      setCsvData([...arr]);
    }
  }, [tenderLogs, tenderData]);

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'All Tenders', path: routesName.tenderListing },
    { title: 'Tender Detail' },
  ];

  return (
    <div>
      <div className="mb-6">
        <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      </div>
      <div className="text-2xl">Tender Detail</div>

      <div className="mt-12 mx-auto">
        <div className="flex flex-col gap-4">
          <div>
            <Tabs
              orientation={'horizontal'}
              variant="scrollable"
              value={activeTab}
              onChange={(e, value) => setActiveTab(value)}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab label="Project Information" {...a11yProps(0)} />
              <Tab label="Files" {...a11yProps(1)} />
              <Tab label="Bid List" {...a11yProps(2)} />
              <Tab label="Message" {...a11yProps(3)} />
              <Tab label="Audit Trail" {...a11yProps(4)} />
            </Tabs>
          </div>
          {!loading && (
            <div className="flex-1 px-4">
              <TabPanel value={activeTab} index={0}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <span className="font-bold">Title of Tender:</span>
                    {tenderData?.tenderTitle}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Ref No: </span>
                    {tenderData?.refNo}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Publication Date:</span>
                    {tenderData?.publicationDate}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Time:</span>
                    {tenderData?.publicationTime}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold"> Time Zone:</span>
                    {tenderData?.publicationTimeZone}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Submission Deadline:</span>
                    {tenderData?.submissionDate}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Time:</span>
                    {tenderData?.submissionTime}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Time Zone:</span>
                    {tenderData?.submissionTimeZone}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">
                      Beneficiary Geographical Location:{' '}
                    </span>

                    {tenderData?.beneficiatyLocation}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">UNSPSC and CPV Codes:</span>
                    {tenderData?.unspscAndCpvCode}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Procedure Type: </span>
                    {tenderData?.procedureType}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Introduction:</span>
                    {tenderData?.introduction}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold"> Submission Instructions:</span>{' '}
                    {tenderData?.submissionInstructions}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">Deadline for quries:</span>
                    {tenderData?.deadlineForQueries}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">User/Key 1:</span>
                    {tenderData?.userKey1}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold">User/Key 2:</span>
                    {tenderData?.userKey2}
                  </Grid>
                  <Grid item xs={12}>
                    <span className="font-bold"> User/Key 3:</span>
                    {tenderData?.userKey3}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    {Array.isArray(tenderData.files) &&
                      tenderData.files.map((item, index) => {
                        return (
                          <div
                            key={index + item}
                            className="flex gap-2 items-center text-[var(--dark-blue)]"
                          >
                            <a href={toAbsolutePath(item)} target="_blank">
                              {toAbsolutePath(item)}
                            </a>
                          </div>
                        );
                      })}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <Grid container spacing={2}>
                  {Array.isArray(bids) &&
                    bids.map((item, index) => (
                      <Grid key={item._id} item md={6} xs={12}>
                        <div className="bg-white md:p-3 p-2 rounded-md">
                          <div className="flex justify-between items-center">
                            <div>
                              <span className="font-semibold">Name : </span>
                              {item?.user?.name}
                            </div>
                            <div>
                              {moment(item?.updatedAt).format('DD-MM-YYYY')}
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                </Grid>
              </TabPanel>
              <TabPanel value={activeTab} index={3}>
                <Grid container spacing={2}>
                  {Array.isArray(messages) &&
                    messages.map((message, index) => (
                      <Grid key={message._id} item xs={12}>
                        <div
                          className={`p-3 ${
                            user?._id === message?.sender?._id
                              ? 'bg-blue-200'
                              : 'bg-white'
                          }`}
                        >
                          <div className="flex gap-2">
                            <div className="font-bold">
                              {message?.sender?.name}
                            </div>
                            <div className="text-sm">to </div>
                            <div className="font-bold">
                              {message?.receiver?.name}
                            </div>
                          </div>
                          <div className="font-bold text-sm">
                            {message?.title}
                          </div>
                          <div className="text-sm">{message?.message}</div>
                          <div className="flex justify-end">
                            {user?._id !== message?.sender?._id && (
                              <button
                                onClick={() => {
                                  setReplyTo(message);
                                  toggleMessagePopup();
                                }}
                                className="md:text-md text-xs text-white bg-[var(--pink)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                              >
                                Reply
                              </button>
                            )}
                          </div>
                        </div>
                      </Grid>
                    ))}
                  {/* <MessagePopup
                    close={toggleMessagePopup}
                    open={isMessagePopup}
                    receivers={[replyTo?.sender?._id]}
                    bidId={replyTo?.bid?._id}
                    tenderId={replyTo?.tender?._id}
                    replyTo={replyTo._id}
                    onSuccess={() => {
                      getChatsByTender();
                    }}
                  /> */}
                  <Modal
                    open={isMessagePopup}
                    onClose={() => {
                      toggleMessagePopup();
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        minWidth: 300,
                        bgcolor: '#fff',
                        borderRadius: '10px',
                        boxShadow: 24,
                        p: 2,
                      }}
                    >
                      <div className="text-lg font-bold">New Message</div>

                      <SendChat
                        replyTo={replyTo.chatGroup}
                        replying={'me'}
                        receiver={replyTo?.sender?._id}
                        tender={replyTo?.tender}
                        onSuccess={() => {
                          toggleMessagePopup();
                          getChatsByTender();
                        }}
                        onCancel={() => {
                          toggleMessagePopup();
                        }}
                      />
                    </Box>
                  </Modal>
                </Grid>
              </TabPanel>
              <TabPanel value={activeTab} index={4}>
                <div>
                  <div className="flex justify-end mb-3">
                    <CSVLink
                      data={csvData}
                      filename="tender-logs.csv"
                      className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Download CSV
                    </CSVLink>
                  </div>
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3">
                            Changed By
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Changed At
                          </th>
                          <th scope="col" className="px-6 py-3">
                            History
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(tenderLogs) &&
                          tenderLogs.map((log, index) => (
                            <tr
                              key={index}
                              className="odd:bg-white even:bg-gray-50 border-b"
                            >
                              <th
                                scope="row"
                                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                              >
                                {log?.updatedBy?.name}
                              </th>
                              <td className="px-6 py-4">{log?.createdAt}</td>
                              <td className="px-6 py-4">
                                <table>
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr>
                                      <th scope="col" className="px-6 py-3">
                                        Changed
                                      </th>
                                      <th scope="col" className="px-6 py-3">
                                        Old Value
                                      </th>
                                      <th scope="col" className="px-6 py-3">
                                        New Value
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Array.isArray(log?.changes) &&
                                      log?.changes.map((change, ind) => (
                                        <tr key={ind}>
                                          <td>{change.key}</td>
                                          <td>{change.old}</td>
                                          <td>{change.new}</td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </TabPanel>
            </div>
          )}
        </div>
      </div>
      <Modal
        open={isViewBid}
        onClose={() => {
          toggleViewBid();
          setModalData();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: 300,
            bgcolor: '#fff',
            borderRadius: '10px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <div className="text-lg font-bold">Submitted Bid</div>
          <hr />
          {modalData?.files &&
            Array.isArray(modalData.files) &&
            modalData.files.map((file, index) => (
              <div key={index} className="flex gap-4 items-center">
                <span>{index + 1} : </span>
                <a
                  className="text-[var(--blue)]"
                  href={toAbsolutePath(file)}
                  target="_blank"
                >
                  Open
                </a>
                <a
                  className="text-[var(--pink)]"
                  href={toAbsolutePath(file)}
                  target="_blank"
                  download={file}
                >
                  Download
                </a>
              </div>
            ))}
        </Box>
      </Modal>
    </div>
  );
}

export default Component;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <h1>{children}</h1>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
